module.exports = __webpack_public_path__ + "img/restaurant_bodyimage04.04e33546.jpg";